// removed by extract-text-webpack-plugin
module.exports = {"accountInfo":"_1Ypp_9G-xF6uIMb9aKMXlf","title":"_36luo1CSJXcjXjLeg-9XzH","formInfo":"_1mH5-Ru6wA5qEMstGzMrsn","avatar":"_13h871F20LV5GiaRrAgNh","inputCol":"_2X94z3JFkBKX-NlkYiCncY","labelCol":"Olp5NXvwZlNnkqIdttfO8","fullWidth":"hnmnDJ27UnF9f5BLzFgsL","buttonSave":"_3-F-l3bUZFIYYdUjHZTCLF","modalAlert":"_1n-Tk2usWprG_FjjG3DHE2","headerAlert":"_3bn4x9zOkFLCgfPgrIyibW","contentAlert":"_30Pk0qjZQxQvvAif7jlM7J","actionButtons":"bgJ2E4gYSx3bDhMfEz2li","btnLogin":"_2YWcX66sTEdx668FvoZ2hh","phone":"_22_3R6yCRUoNlybaC2P0DI","icon":"Hdi3o9H1HHV8ZnWYO9HzN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountManagement/AccountInfo.scss
// module id = 1078
// module chunks = 0